import { CellProps } from "./Cell";
import { RowProps } from "./Row";

export interface CellModel extends CellProps {}
export interface RowModel extends RowProps {}

/**
 * if the first row or column is sticky, then we need to manually set the z-index so that the very first cell has the highest z-index
 *
 * @export
 * @param {boolean} sticky
 * @param {number} index
 * @returns {(number | undefined)}
 */
export function getZIndex(sticky: boolean, index: number): number | undefined {
    if (sticky) {
        return 100 - index;
    }

    return undefined;
}
